// extracted by mini-css-extract-plugin
module.exports = {"label":"AccountSettingsPage_label__16XKf","user":"AccountSettingsPage_user__42GsC","role":"AccountSettingsPage_role__2vSxF"};